import React from 'react';
import PropTypes from 'prop-types';
import Container from '../../General/Container';
import Button from '../../General/Button';
import DetailsBlock from './DetailsBlock';
import { RefreshIcon } from '../../../images/mis-boletas';

import useUser from '../../../hooks/useUser';
import { Wrapper, Title } from './styles/CurrentInvoiceStyled';

import Divider from '../../General/Divider';

const CurrentInvoice = ({ data, loadFunc, status }) => {
  const { paymentUrl } = useUser();

  const hasStatusPaid = status.toUpperCase() === 'PAID';

  return (
    <Container background="#fff" boxShadow="0px 2px 4px rgba(45, 20, 65, 0.15)">
      <Wrapper>
        <Title>
          <p>{`Resumen de boleta ${data.lastInvoice.month}`}</p>
          <Button
            margin="0"
            outline
            color="purple"
            height="35px"
            width="155px"
            click={() => loadFunc(true)}
          >
            <RefreshIcon style={{ marginRight: '10px' }} />
            <span>Actualizar</span>
          </Button>
        </Title>
        <Divider color="#97979740" lineStyle="dashed" margin="15px 0 30px 0" />
        <DetailsBlock
          loadFunc={loadFunc}
          data={data}
          hasStatusPaid={hasStatusPaid}
          paymentUrl={paymentUrl}
        />
      </Wrapper>
    </Container>
  );
};

CurrentInvoice.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  loadFunc: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default CurrentInvoice;
